module.exports = __webpack_public_path__ + "media/VocnaNargila.cb435a1c.mp4";